import { ZAttrMeta } from "./ZAttrMeta";

export const sortedAttributes = (
  list: ZAttrMeta[] | null | undefined,
): ZAttrMeta[] => {
  if (!list) return [];
  const newList = [...list];
  newList.sort((a: ZAttrMeta, b: ZAttrMeta) => {
    const orderA: number = a.edit?.order ?? 0;
    const orderB: number = b.edit?.order ?? 0;
    return orderA - orderB;
  });
  return newList;
};
